<template>
    <div class="flex items-center justify-between p-6 border-b-2 border-indigo-400">
        <h1 class="text-3xl text-bold text-gray-900 dark:text-gray-100">Profil</h1>
        <LoaderButton title="Enregistrer" @ok="save()" :disabled="checkFieldValid" ref="btnValidate"></LoaderButton>
    </div>  
    <div class="px-6 pb-6 pt-3 border-b-2 border-indigo-400">
        <div class="flex flex-wrap rounded">
            <div class="w-full md:w-1/6 mb-6 px-2 md:mb-0 mt-4">
                <label class="form-label" for="genre">
                    Genre*
                </label>
                <div
                    class="relative"
                >
                    <Multiselect
                        v-model='genderState'
                        id='genre'
                        :options="genderOptions"
                        label="libelle"
                        track-by="libelle"
                        v-bind="$multiselectEmptyBind"
                    />
                </div>
            </div>
            <div class="w-full md:w-5/12 mb-6 px-2 md:mb-0 mt-4">
                <AppInput
                    v-model='prenomState'
                    title='Prénom'
                    id='prenom'
                    :validations="['required']"
                    @hasError="handleFormError"
                />
            </div>
            <div class="w-full md:w-5/12 mt-4 px-2">
                <AppInput v-model='nomState' title='Nom' id='nom' :validations="['required']" @hasError="handleFormError"/>
            </div>
        </div>
        <div class="flex flex-wrap rounded">
            <div class="w-full md:w-1/2 mt-4 px-2">
                <AppInput v-model='emailState' title='Email' id='email' :disabled='true'/>
            </div>
            <div class="w-full md:w-1/2 mt-4 px-2">
                <AppInput v-model='telephoneState' title='Téléphone' id='telephone'/>
            </div>
        </div>
        <div class="flex flex-wrap rounded">
            <div class="w-full md:w-2/4 mt-4 px-2 md:mb-0">
                <AppInput v-model='adresseState' title='Adresse' id='adresse'/>
            </div>
            <div class="w-full md:w-1/4 mt-4 px-2 md:mb-0">
                <AppInput v-model='villeState' title='Ville' id='ville'/>
            </div>
            <div class="w-full md:w-1/4 mt-4 px-2">
                <AppInput v-model='cpState' title='Code postal' id='codePostal'/>
            </div>
        </div>
    </div>
</template>

<script>

import LoaderButton from '../form/LoaderButton';
import AppInput from '../form/AppInput';
import { useVModel } from '../composables/useVModel'
import Multiselect from 'vue-multiselect'
import { mapGetters } from "vuex";

export default {
    components: {
        LoaderButton,
        AppInput,
        Multiselect,
    },
    data() {
        return {
            formInvalid: [],
        }
    },
    computed: {
        checkFieldValid() {
            return this.formInvalid.length !== 0;
        },
        ...mapGetters({
            genderOptions: 'getGenderOptions',
        }),
    },
    methods: {
        save() {
            if (this.checkFieldValid) {
                return;
            }
            this.$emit('save')
        },

        openChangePasswordModal() {
            this.$refs.changePasswordModal.openModal();
        },

        handleFormError(event) {
            if (event.value && !this.formInvalid.includes(event.name)) {
                this.formInvalid.push(event.name);
            }

            if (!event.value && this.formInvalid.includes(event.name)) {
                this.formInvalid = this.formInvalid.filter(f => f !== event.name)
            }
        },

        activateLoader() {
            this.$refs.btnValidate.activateLoader();
        },

        deactivateLoader() {
            this.$refs.btnValidate.deactivateLoader();
        }
    },
    emits: [
        'update:nom',
        'update:prenom',
        'update:gender',
        'update:email',
        'update:telephone',
        'update:adresse',
        'update:cp',
        'update:ville',
        'update:uuid',
        'save'
    ],
    props: {
        nom: String, 
        prenom: String, 
        gender: Object,
        telephone: String, 
        email: String, 
        adresse: String,
        cp: String,
        ville: String,
        uuid: String,
    },
    setup(props) {
        return {
            nomState: useVModel(props, 'nom'),
            prenomState: useVModel(props, 'prenom'),
            genderState: useVModel(props, 'gender'),
            emailState: useVModel(props, 'email'),
            telephoneState: useVModel(props, 'telephone'),
            adresseState: useVModel(props, 'adresse'),
            cpState: useVModel(props, 'cp'),
            villeState: useVModel(props, 'ville'),
            uuidState: useVModel(props, 'uuid'),
        }
    },
};
</script>